import i18nEnum from '@/i18ns/vi/i18nEnum';

export default [
  {
    path: '/begin-year-arrgrate/:key?',
    name: 'beginYearEstimateArrgrate',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/estimateArrgrate/beginYearEstimateArrgrate/BeginYearEstimateArrgrate.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.PTC, i18nEnum.OrganizationPackCodeType.STC],
    },
  },
   {
    path: '/estimate-finance-three-year/:key?',
    name: 'estimateFinanceThreeYear',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/estimateFinanceThreeYear/ThreeYearEstimate.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.PTC, i18nEnum.OrganizationPackCodeType.STC],
    },
  },
];
